/* eslint-disable @next/next/inline-script-id */
import { MantineProvider } from "@mantine/core";
import { NotificationsProvider } from "@mantine/notifications";
import { SessionProvider } from "next-auth/react";
import type { CustomAppPage } from "next/app";
import Head from "next/head";
import Script from "next/script";
import { Provider } from "react-redux";
import { AuthGuard } from "src/component/element";
import { RegistrationCheck } from "src/component/element/RegistrationCheck";
import { TutorialViewMemo } from "src/component/element/Tutorial";
import { NotificationUserProvider } from "src/component/pageComponent/Notification/Provider/NotificationUserProvider";
import { PageCount } from "src/hooks/MissionCount/MissionCount";
import { PageView } from "src/hooks/PageView/PageView";
import { MantineTheme } from "src/lib/mantine";
import { LocalFontProvider } from "src/lib/nextfont";
import { store } from "src/store";

import "../styles/base.scss";
import "../styles/reset.scss";

const App: CustomAppPage = ({
  Component,
  pageProps: { session, ...pageProps },
}) => {
  const getLayout =
    Component.getLayout ||
    ((page) => {
      return page;
    });

  const id =
    process.env.NEXT_PUBLIC_MODE === "PRODUCTION"
      ? "G-9BZDJCV185"
      : "G-96LEK6L8VX";
  return (
    <>
      <Head>
        <title>TANQ BASE</title>
        <meta
          name="viewport"
          content="minimum-scale=1, initial-scale=1, width=device-width"
        />
        <link href="/favicon.ico" rel="shortcut icon" />
      </Head>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${id}`}
      ></Script>
      <Script>
        {`window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', '${id}');`}
      </Script>
      <SessionProvider
        session={session}
        refetchInterval={5 * 60}
        refetchOnWindowFocus
      >
        <Provider store={store}>
          <LocalFontProvider>
            <MantineProvider theme={MantineTheme}>
              <NotificationsProvider
                position="top-center"
                limit={1}
                zIndex={1000}
              >
                <NotificationUserProvider>
                  <PageView />
                  <PageCount>
                    {Component.requireAuth ? (
                      <AuthGuard>
                        <RegistrationCheck>
                          <TutorialViewMemo>
                            {getLayout(<Component {...pageProps} />)}
                          </TutorialViewMemo>
                        </RegistrationCheck>
                      </AuthGuard>
                    ) : (
                      <TutorialViewMemo>
                        {getLayout(<Component {...pageProps} />)}
                      </TutorialViewMemo>
                    )}
                  </PageCount>
                </NotificationUserProvider>
              </NotificationsProvider>
            </MantineProvider>
          </LocalFontProvider>
        </Provider>
      </SessionProvider>
    </>
  );
};

export default App;
